<template>
  <div class="download-container">
    <header class="download-header">
      <p class="download-title reveal-bottom">
        {{ $t("m100.download_title") }}
      </p>
    </header>
    <div class="container">
      <div class="content reveal-bottom">
        <!-- M100客户端 -->
        <div class="content-box" style="margin-right: 48px">
          <div style="margin-bottom: 16px">
            <span class="content-img"></span>
            <span class="content-title">{{ $t("m100.download_m100") }}</span>
          </div>
          <div class="content-desc" style="margin-bottom: 16px">
            {{ $t("m100.download_tip") }}
          </div>
          <div>
            <p class="content-download" @click="goM100">
              {{ $t("m100.download_start") }}
              <span class="content-arrow"></span>
            </p>
          </div>
        </div>
        <!-- 云安通客户端 -->
        <div class="content-box" style="margin-right: 48px">
          <div style="margin-bottom: 16px">
            <span class="content-img yat-img"></span>
            <span class="content-title">{{
              $t("m100.download_e_connect")
            }}</span>
          </div>
          <div class="content-desc" style="margin-bottom: 16px">
            {{ $t("m100.download_tip2") }}
          </div>
          <div>
            <p class="content-download" @click="goYat">
              {{ $t("m100.download_start") }}
              <span class="content-arrow"></span>
            </p>
          </div>
        </div>
      </div>

      <div class="content reveal-bottom">
        <!-- SASE客户端 -->
        <div class="content-box">
          <div style="margin-bottom: 16px">
            <span class="content-img sase-img"></span>
            <span class="content-title">{{ $t("m100.download_sase") }}</span>
          </div>
          <div class="content-desc" style="margin-bottom: 16px">
            {{ $t("m100.download_sase_tip") }}
          </div>
          <div>
            <p class="content-download" @click="goSase">
              {{ $t("m100.download_start") }}
              <span class="content-arrow"></span>
            </p>
          </div>
        </div>
        <!-- NetTool客户端 -->
        <div class="content-box" style="margin-right: 48px">
          <div style="margin-bottom: 16px">
            <span class="content-img nt-img"></span>
            <span class="content-title">{{ $t("m100.download_nt") }}</span>
          </div>
          <div class="content-desc" style="margin-bottom: 16px">
            {{ $t("m100.download_nt_tip") }}
          </div>
          <div>
            <p class="content-download" @click="goNtTool">
              {{ $t("m100.download_start") }}
              <span class="content-arrow"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import initAnimation from "../animation";
export default {
  data() {
    return {
      img: require("@/assets/images/download/d-bg.png"),
    };
  },
  mounted() {
    setTimeout(initAnimation, 0);
  },
  methods: {
    back: function () {
      this.$router.back();
    },
    goM100: function () {
      this.$router.push({ path: `/Download-M100` });
    },
    goYat: function () {
      this.$router.push({ path: `/Download-YAT` });
    },
    goSase: function () {
      this.$router.push({ path: `/Download-Sase` });
    },
    goNtTool: function () {
      this.$router.push({ path: `/Download-Tool` });
    },
  },
};
</script>

<style scoped>
.download-header {
  width: 100%;
  height: 230px;
  line-height: 230px;
  text-align: center;
  background-image: url("../../assets/images/download/d-bg.png");
  background-size: cover;
}
.download-title {
  font-weight: 600;
  font-size: 36px;
  color: #000000;
  font-style: normal;
  text-transform: none;
}
.container {
  padding: 80px 0 128px 0;
}
.content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.content-box {
  flex: 1;
  padding: 20px;
  box-sizing: border-box;
}
.content-img {
  display: inline-block;
  width: 58px;
  height: 58px;
  background-image: url("../../assets/images/download/m100.png");
  background-size: cover;
  margin-right: 16px;
}
.yat-img {
  background-image: url("../../assets/images/download/yat.png");
}
.sase-img {
  background-image: url("../../assets/images/download/d-sase.png");
}
.nt-img {
  background-image: url("../../assets/images/download/d-nt.png");
}
.content-title {
  height: 58px;
  line-height: 58px;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.content-desc {
  font-weight: 400;
  font-size: 20px;
  color: #909090;
  line-height: 30px;
  text-align: justified;
  font-style: normal;
  text-transform: none;
}
.content-download {
  font-weight: 400;
  font-size: 20px;
  color: #00a3d1;
  text-align: left;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
  display: inline-block;
}
.content-arrow {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-image: url("../../assets/images/download/d-arrow.png");
  background-size: cover;
  margin-left: 8px;
  vertical-align: top;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/Pages/Download/Download.vue